


// import React, { useEffect, useState } from 'react';

// export default function Gauge({ value, label }) {
//   const [offset, setOffset] = useState(125.6);
//   const [rotation, setRotation] = useState(-90);
  
//   const max = 12; // Adjusted for pressure range
//   const percentage = Math.min((value / max) * 100, 100);

//   useEffect(() => {
//     const animationTimeout = setTimeout(() => {
//       setOffset(125.6 - (125.6 * percentage) / 100);
//       setRotation((percentage / 100) * 180 - 90);
//     }, 150);
//     return () => clearTimeout(animationTimeout);
//   }, [value, percentage]);

//   return (
//     <div className="gauge">
//       <div className="speedometer-container" style={{ width: '100%', maxWidth: '140px' }}>
//         <svg viewBox="0 0 100 60">
//           <defs>
//             <linearGradient id="gaugeGradient" x1="0%" y1="0%" x2="100%" y2="0%">
//               <stop offset="0%" stopColor="#008cff" />
//               <stop offset="100%" stopColor="#00ffd5" />
//             </linearGradient>
//           </defs>
//           <path d="M 10 50 A 40 40 0 0 1 90 50" fill="none" stroke="#1a202c" strokeWidth="6" strokeLinecap="round" />
//           <path d="M 10 50 A 40 40 0 0 1 90 50" fill="none" stroke="url(#gaugeGradient)" strokeWidth="6" strokeLinecap="round"
//             strokeDasharray="125.6" strokeDashoffset={offset} className="gauge-progress-path" />
//           <line x1="50" y1="50" x2="50" y2="15" stroke="white" strokeWidth="2" strokeLinecap="round"
//             style={{ transform: `rotate(${rotation}deg)`, transformOrigin: '50px 50px' }} className="gauge-needle" />
//           <circle cx="50" cy="50" r="3" fill="var(--neon-cyan)" />
//         </svg>
//       </div>
//       <div style={{ textAlign: 'center', marginTop: '-5px' }}>
//         <h2 style={{ margin: 0, fontSize: '1.4rem' }}>{value}</h2>
//         <p style={{ margin: 0, fontSize: '0.65rem', color: 'var(--text-dim)' }}>kg/cm²</p>
//         <p style={{ marginTop: '5px', fontSize: '0.7rem', fontWeight: '600', color: 'var(--neon-cyan)' }}>{label}</p>
//       </div>
//     </div>
//   );
// }
import React, { useEffect, useState } from 'react';
import './gauge.css';

export default function Gauge({ value, label }) {
  const max = 25;
  const arcLength = 125.6;
  const [offset, setOffset] = useState(arcLength);
  const [rotation, setRotation] = useState(-90);
  
  const percentage = Math.min((value / max) * 100, 100);

  useEffect(() => {
    const timer = setTimeout(() => {
      setOffset(arcLength - (arcLength * percentage) / 100);
      // Math: 0% = -90deg (Left), 50% = 0deg (Top), 100% = 90deg (Right)
      setRotation((percentage / 100) * 180 - 90);
    }, 150);
    return () => clearTimeout(timer);
  }, [value, percentage]);

  return (
    <div className="gauge-card-pro">
      <div className="gauge-visual-container" style={{ position: 'relative' }}>
        <svg viewBox="0 0 100 60" className="gauge-svg">
          <defs>
            <linearGradient id="slateGrad" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#2563eb" />
              <stop offset="100%" stopColor="#0ea5e9" />
            </linearGradient>
          </defs>
          
          {/* Background Track */}
          <path d="M 10 50 A 40 40 0 0 1 90 50" fill="none" stroke="#f1f5f9" strokeWidth="5" strokeLinecap="round" />
          
          {/* Progress Path */}
          <path 
            d="M 10 50 A 40 40 0 0 1 90 50" 
            fill="none" 
            stroke="url(#slateGrad)" 
            strokeWidth="5" 
            strokeLinecap="round"
            strokeDasharray={arcLength} 
            strokeDashoffset={offset} 
            style={{ transition: 'stroke-dashoffset 1.5s ease-out' }}
          />
          
          {/* THE NEEDLE: Pointing at the scale */}
          <g style={{ 
              transform: `rotate(${rotation}deg)`, 
              transformOrigin: '50px 50px', // Crucial: rotates around the bottom center
              transition: 'transform 1.5s cubic-bezier(0.34, 1.56, 0.64, 1)' 
            }}>
            {/* The polygon points:
               Base Left: 48.5, 50
               Base Right: 51.5, 50
               Tip: 50, 15 (reaching toward the arc)
            */}
            <polygon points="48.5,50 51.5,50 50,15" fill="#0f172a" />
          </g>
          
          {/* Center Hub (Covers the base of the needle) */}
          <circle cx="50" cy="50" r="3.5" fill="#0f172a" />
          <circle cx="50" cy="50" r="1.5" fill="#94a3b8" />
        </svg>

        <div className="gauge-value-box">
          <span className="v-number">{value}</span>
          <span className="v-unit">kg/cm²</span>
        </div>
      </div>
      
      <div className="gauge-label-tag">{label}</div>
    </div>
  );
}